import { render, staticRenderFns } from "./reminderDetail.vue?vue&type=template&id=168aa0e3&"
import script from "./reminderDetail.vue?vue&type=script&lang=js&"
export * from "./reminderDetail.vue?vue&type=script&lang=js&"
import style0 from "./reminderDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports